import { Avatar, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import INftCard from 'interfaces/NftCard.interface';
import React, { useEffect, useState, RefObject, SetStateAction } from 'react';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';
import {
  SenderBox,
  MessageText,
  TipPriceBox,
  TipBox,
  TipText,
  RecieverBox,
  Body,
  imgStyles,
  ReplyImgStyles,
  PostBox,
} from './Styles';
import NftCard from '../Card/NftCard';
import ImgModal from '../imgModal';
import Options from './Options';
import { IMessage } from 'interfaces/message.interface';
import ReadTicks from './ReadTicks';
import { NormalButton } from 'components/atoms/Button';
import { updateUser } from 'APIs/AuthApi';
import { useAppSelector, useImageLoaded } from 'app/hooks';
import { inviteCreator, selectAuth } from 'features/auth/authSlice';
import { useDispatch } from 'react-redux';
import Backstage from 'interfaces/Backstage.interface';
import { postBackstage } from 'APIs/BackstageApi';
import { checkSub, updateMessageClicked } from 'APIs/utils';
import Loader from 'components/atoms/loader';
import { UserData } from 'interfaces/UserData.interface';
import './styles.css';
import LockContent from './LockContent';

// const VideoPlayer = require("react-simple-video-player");

export enum MessageDataType {
  time = 1,
  video = 2,
  image = 3,
  tip = 4,
  nft = 5,
  invite = 6,
  collab = 7,
}

interface dMessageBoxProps {
  messageSender: 'you' | 'me';
  senderAvatar: string;
  recieverAvatar: string;
  text?: string;
  reaction?: string[];
  messageDataType?: MessageDataType;
  nft?: INftCard;
  msgId: string;
  userId: number;
  username: string;
  messages: IMessage[];
  repliedTo?: IMessage;
  repliedToType?: MessageDataType;
  isRead: boolean;
  isSent: boolean;
  senderId: number;
  post?: Partial<Backstage>;
  isClicked?: boolean;
  isLocked?: boolean;
  isPending?: boolean;
  user: UserData;
  scrollIntoViewElem: RefObject<HTMLDivElement>;
  setIsCreator: SetStateAction<any>;
}
const DMessageBox: React.FC<dMessageBoxProps> = ({
  messageDataType,
  text,
  messageSender,
  nft,
  senderAvatar,
  recieverAvatar,
  msgId,
  messages,
  userId,
  reaction,
  repliedTo,
  repliedToType,
  username,
  isRead,
  isSent,
  senderId,
  post,
  isClicked,
  isLocked,
  isPending,
  user,
  scrollIntoViewElem,
  setIsCreator,
}) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');
  const CardImg = require('assets/AuctionBg.png');
  const authState = useAppSelector(selectAuth);
  const [clicked, setClicked] = useState<boolean>(isClicked || false);
  const [loading, setLoading] = useState<boolean>(false);
  const [transaction, setTransaction] = useState<boolean>(false);
  const [isSubscribed, setIsSubscribed] = useState<boolean>(false);

  const [, setSubscribed] = useState<boolean>(false);
  const [, setError] = useState<boolean>(false);
  const [, setSubLoading] = useState<boolean>(false);
  const [ref, loaded, onLoad] = useImageLoaded();
  const dispatch = useDispatch();

  const isMedia = () => {
    switch (messageDataType) {
      case 2:
        return true;
      case 3:
        return true;
      case 5:
        return true;
      case 6:
        return true;
      case 7:
        return true;

      default:
        return false;
    }
  };
  const updateCreator = async () => {
    try {
      const updateCreator = await updateUser({
        id: messageSender === 'me' ? senderId : authState.id,
        isCreator: true,
      });
      if (updateCreator)
        await updateUser({
          id: messageSender === 'me' ? authState.id : senderId,
          invites: authState.invites - 1,
        });
      dispatch(inviteCreator());
      setIsCreator(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (scrollIntoViewElem.current && loaded)
      scrollIntoViewElem.current.scrollIntoView();
  }, [loaded, scrollIntoViewElem]);

  const approvePost = async () => {
    try {
      setLoading(true);
      if (post) {
        const createPost = await postBackstage(post, true);
        if (createPost && authState.id) {
          updateMessageClicked(authState.id, senderId, msgId);
          setClicked(true);
          setLoading(false);
        }
      } else throw new Error('No post given to send.');
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const declinePost = async () => {
    try {
      setLoading(true);
      if (post) {
        if (authState.id) {
          updateMessageClicked(authState.id, senderId, msgId);
          setClicked(true);
          setLoading(false);
        }
      } else throw new Error('No post given to send.');
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    isPending &&
      checkSub(
        setSubLoading,
        authState,
        setSubscribed,
        setIsSubscribed,
        setTransaction,
        dispatch,
        user,
        false,
        undefined,
        undefined,

        true,
        setError,
        setLoading,
        authState.id,
        userId,
        msgId
      );
    //eslint-disable-next-line
  }, [isPending]);

  const message: { [key in MessageDataType]: JSX.Element } = {
    [MessageDataType.time]: <></>,
    [MessageDataType.video]: (
      <LockContent
        isLocked={isLocked}
        isPending={isPending}
        isSubscribed={isSubscribed}
        transaction={transaction}
        loading={loading}
        userId={userId}
        msgId={msgId}
        senderId={senderId}
        user={user}
        setError={setError}
        setIsSubscribed={setIsSubscribed}
        setLoading={setLoading}
        setTransaction={setTransaction}
      >
        <ReactPlayer
          width={isMobile ? '80vw' : undefined}
          height={isMobile ? '300px' : undefined}
          url={text}
          controls
          ref={ref}
        />
      </LockContent>
    ),
    [MessageDataType.image]: (
      <LockContent
        isLocked={isLocked}
        isPending={isPending}
        isSubscribed={isSubscribed}
        transaction={transaction}
        loading={loading}
        userId={userId}
        msgId={msgId}
        senderId={senderId}
        user={user}
        setError={setError}
        setIsSubscribed={setIsSubscribed}
        setLoading={setLoading}
        setTransaction={setTransaction}
      >
        <ImgModal src={text}>
          <img
            style={{ ...imgStyles, width: isMobile ? '50vw' : undefined }}
            src={text}
            alt=""
            ref={ref}
            onLoad={onLoad}
          />
        </ImgModal>
      </LockContent>
    ),
    [MessageDataType.tip]: (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <TipBox>
          <TipText>{text}</TipText>
          <TipPriceBox>
            <MessageText>$25</MessageText>
          </TipPriceBox>
        </TipBox>
      </Box>
    ),
    [MessageDataType.nft]: nft ? (
      <LockContent
        isLocked={isLocked}
        isPending={isPending}
        isSubscribed={isSubscribed}
        transaction={transaction}
        loading={loading}
        userId={userId}
        msgId={msgId}
        senderId={senderId}
        user={user}
        setError={setError}
        setIsSubscribed={setIsSubscribed}
        setLoading={setLoading}
        setTransaction={setTransaction}
      >
        <NftCard
          ownerName={nft.ownerName}
          name={nft.name}
          views={+nft.views}
          splitWith={nft.splitWith}
          currency={nft.currency}
          price={nft.price}
          image={nft.image}
          poster={nft.poster}
        />
      </LockContent>
    ) : (
      <></>
    ),
    [MessageDataType.invite]: (
      <NormalButton
        color="yellow"
        isDisabled={authState.isCreator}
        text={text}
        onClick={updateCreator}
      />
    ),
    [MessageDataType.collab]: (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <PostBox>{user.username} has requested to collaborate</PostBox>
        <PostBox>{post?.content}</PostBox>
        <img
          style={{ width: '300px', height: 'auto', borderRadius: '10px' }}
          src={post ? (post.images ? post.images[0] : undefined) : undefined}
          alt=""
        />
        <PostBox
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: '10px 0px',
          }}
        >
          <span> split percentage {post?.splitPercent}%</span>
          <span>{post?.price}$</span>
        </PostBox>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <NormalButton
            color="yellow"
            text={
              loading ? (
                <Loader size="1" />
              ) : clicked ? (
                'Post Approved'
              ) : (
                'Approve post'
              )
            }
            isDisabled={senderId === authState.id || clicked || loading}
            onClick={approvePost}
          />
          <NormalButton
            color="transparent"
            text={
              loading ? (
                <Loader size="1" />
              ) : clicked ? (
                'Post Declined'
              ) : (
                'Decline post'
              )
            }
            isDisabled={senderId === authState.id || clicked || loading}
            onClick={declinePost}
          />
        </div>
      </div>
    ),
  };

  const repliedToMessage: { [key in MessageDataType]: JSX.Element } = {
    [MessageDataType.time]: <></>,
    [MessageDataType.video]: (
      <LockContent
        isLocked={isLocked}
        isPending={isPending}
        isSubscribed={isSubscribed}
        transaction={transaction}
        loading={loading}
        userId={userId}
        msgId={msgId}
        senderId={senderId}
        user={user}
        setError={setError}
        setIsSubscribed={setIsSubscribed}
        setLoading={setLoading}
        setTransaction={setTransaction}
      >
        <div>
          <MessageText
            borderRadius={messageSender === 'you' ? '10px' : undefined}
          >
            <ReactPlayer
              width={isMobile ? '80vw' : undefined}
              height={isMobile ? '300px' : undefined}
              url={repliedTo && repliedTo.text}
              controls
              ref={ref}
            />
          </MessageText>
        </div>
      </LockContent>
    ),
    [MessageDataType.image]: (
      <LockContent
        isLocked={isLocked}
        isPending={isPending}
        isSubscribed={isSubscribed}
        transaction={transaction}
        loading={loading}
        userId={userId}
        msgId={msgId}
        senderId={senderId}
        user={user}
        setError={setError}
        setIsSubscribed={setIsSubscribed}
        setLoading={setLoading}
        setTransaction={setTransaction}
      >
        <img
          ref={ref}
          style={ReplyImgStyles}
          src={repliedTo && repliedTo.text}
          alt=""
        />
      </LockContent>
    ),
    [MessageDataType.invite]: (
      <NormalButton color="yellow" text={repliedTo && repliedTo.text} />
    ),
    [MessageDataType.tip]: (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <TipBox>
          <TipText>{repliedTo && repliedTo.text}</TipText>
          <TipPriceBox>
            <MessageText>$25</MessageText>
          </TipPriceBox>
        </TipBox>
      </Box>
    ),
    [MessageDataType.nft]: (
      <LockContent
        isLocked={isLocked}
        isPending={isPending}
        isSubscribed={isSubscribed}
        transaction={transaction}
        loading={loading}
        userId={userId}
        msgId={msgId}
        senderId={senderId}
        user={user}
        setError={setError}
        setIsSubscribed={setIsSubscribed}
        setLoading={setLoading}
        setTransaction={setTransaction}
      >
        <img style={ReplyImgStyles} src={CardImg} alt="" />
      </LockContent>
    ),
    [MessageDataType.collab]: (
      <div>
        <div>{user.username} has requested to collaborate</div>
        <NormalButton
          color="yellow"
          text={
            loading ? (
              <Loader size="1" />
            ) : clicked ? (
              'Post Approved'
            ) : (
              'Approve post'
            )
          }
          isDisabled={senderId === authState.id || clicked || loading}
          onClick={approvePost}
        />
      </div>
    ),
  };

  const RepliedToComponent: React.FC = () => {
    if (repliedTo) {
      if (repliedToType) {
        if (messageDataType) {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: messageSender === 'you' ? 'flex-start' : 'flex-end',
              }}
            >
              {repliedToMessage[repliedToType]}
              <>{message[messageDataType]}</>
            </div>
          );
        } else {
          return (
            <>
              <>{repliedToMessage[repliedToType]}</>
              <MessageText
                borderRadius={messageSender === 'you' ? '10px' : undefined}
              >
                {text}
              </MessageText>
            </>
          );
        }
      } else {
        if (messageDataType) {
          return (
            <>
              <MessageText hidden={true}>{repliedTo.text}</MessageText>
              <>{message[messageDataType]}</>
            </>
          );
        } else {
          return (
            <>
              <MessageText
                borderRadius={messageSender === 'you' ? '10px' : undefined}
                hidden={true}
              >
                {repliedTo.text}
              </MessageText>
              <MessageText
                borderRadius={messageSender === 'you' ? '10px' : undefined}
              >
                {text}
              </MessageText>
            </>
          );
        }
      }
    } else {
      if (messageDataType) return message[messageDataType];
      else return <>{text}</>;
    }
  };

  return (
    <Body>
      {messageSender === 'you' ? (
        nft || post || text ? (
          <div
            className="container-options"
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Avatar
                src={senderAvatar}
                style={{ marginRight: '5px', cursor: 'pointer' }}
                onClick={() => navigate('/profile/gallery')}
              ></Avatar>
              <SenderBox
                style={{
                  backgroundColor: isMedia() || repliedTo ? 'transparent' : '',
                  paddingLeft: isMedia() || repliedTo ? '0px' : '27px',
                  position: 'relative',
                }}
              >
                <RepliedToComponent />
                {reaction ? (
                  reaction.length === 1 ? (
                    <span
                      style={{
                        position: 'absolute',
                        bottom: isMedia() || repliedTo ? '5px' : '-10px',
                        right: isMedia() || repliedTo ? '40px' : '10px',
                        fontSize: '20px',
                      }}
                    >
                      😊
                    </span>
                  ) : reaction.length === 2 ? (
                    <span
                      style={{
                        position: 'absolute',
                        bottom: isMedia() || repliedTo ? '5px' : '-10px',
                        right: isMedia() || repliedTo ? '30px' : '10px',
                        fontSize: '20px',
                      }}
                    >
                      😊{' '}
                      <sub
                        style={{
                          position: 'absolute',
                          fontSize: '11px',
                          bottom: '-5px',
                          right: '-5px',
                          color: 'white',
                          fontWeight: '800',
                        }}
                      >
                        2
                      </sub>
                    </span>
                  ) : (
                    <></>
                  )
                ) : (
                  <></>
                )}
              </SenderBox>
            </Box>

            <Options
              sender={true}
              messages={messages}
              msgId={msgId}
              userId={userId}
              reaction={reaction}
              username={username}
            />
          </div>
        ) : (
          <></>
        )
      ) : nft || post || text ? (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            position: 'relative',
          }}
          className="container-options"
        >
          <Options
            messages={messages}
            msgId={msgId}
            userId={userId}
            reaction={reaction}
            username={username}
          />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <RecieverBox
              style={{
                backgroundColor: isMedia() || repliedTo ? 'transparent' : '',
                paddingRight: isMedia() || repliedTo ? '0px' : '27px',
                position: 'relative',
              }}
            >
              <RepliedToComponent />
              <ReadTicks isSent={isSent} isRead={isRead} />

              {reaction ? (
                reaction.length === 1 ? (
                  <span
                    style={{
                      position: 'absolute',
                      bottom: isMedia() || repliedTo ? '5px' : '-10px',
                      left: isMedia() || repliedTo ? '40px' : '10px',
                      fontSize: '20px',
                    }}
                  >
                    😊
                  </span>
                ) : reaction.length === 2 ? (
                  <span
                    style={{
                      position: 'absolute',
                      bottom: isMedia() || repliedTo ? '5px' : '-10px',
                      left: isMedia() || repliedTo ? '30px' : '10px',
                      fontSize: '20px',
                    }}
                  >
                    😊{' '}
                    <sub
                      style={{
                        position: 'absolute',
                        fontSize: '11px',
                        bottom: '-5px',
                        right: '-5px',
                        color: 'white',
                        fontWeight: '800',
                      }}
                    >
                      2
                    </sub>
                  </span>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
            </RecieverBox>
            <Avatar src={recieverAvatar} style={{ marginLeft: '5px' }}></Avatar>
          </Box>
        </div>
      ) : (
        <></>
      )}
    </Body>
  );
};

export default DMessageBox;
